<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo">{{ title }}</h2>
        <div class="row">
          <div class="col-md-3" v-for="item in items">
            <router-link :to="getUrl(item.id, item.name)" class="evento">
              <img :src="getCover(item)"/>
              <span>
                {{ item.name.substr(0, 40) }}
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!--<template>-->
<!--<div class="row">-->
<!--<loading v-if="! showContent"></loading>-->
<!--<div class="col-xs-12 col-md-12">-->
<!--<h2 v-if="showContent" class="titulo">{{ title }}</h2>-->
<!--</div>-->

<!--<div class="col-md-3" v-for="item in items" :class="[item.id === currentItem.id ? 'atual' : '']">-->
<!--<router-link :to="getUrl(item.id, item.name)">-->
<!--<img :src="getCover(item)"/>-->
<!--<span>{{ item.name }}</span>-->
<!--</router-link>-->
<!--</div>-->

<!--</div>-->
<!--</template>-->
<style>
  #scrollerVertical {
    min-width: 260px;
    max-height: 650px;
    overflow: hidden;
    padding: 10px;
    margin-top: 10px;
  }
</style>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import {slugify} from '../helpers/slugify';
  import HelloWorld from "../components/HelloWorld";

  export default {
    components: {
      HelloWorld,
      Loading
    },
    data() {
      return {
        title: 'Álbuns',
        showContent: false,
        items: [],
        currentItem: [],
        showBanner: true
      }
    },
    mounted() {

    },
    created() {
      let self = this;
      get('albums').then(function (response) {
        self.items = response.data.result.data;
        self.showContent = true;

        if (self.$route.params.id) {
          let currentItem = '';
          self.items.forEach(function (obj) {
            if (obj.id == self.$route.params.id) {
              currentItem = obj;
            }
          }, self);
          self.setCurrentItem(currentItem);
          self.showBanner = false;
        }
      });
    },
    methods: {
      getCover(item) {
        let imageCover = '';
        item.images.forEach(function (obj) {
          if (obj.imageCover && obj.imageCover !== '') {
            imageCover = obj.imageCover;
          }
        });

        if (imageCover === '') {
          item.images.forEach(function (obj) {
            if (obj.image && obj.image !== '') {
              imageCover = obj.image;
            }
          });
        }
        return imageCover;
      },
      getImage(image) {
        if (image.imageCover) {
          return image.imageCover;
        } else {
          return image.image;
        }
      },
      getUrl(id, string) {
        return '/album/' + id + '/' + slugify(string);
      },
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// src/views/Albums.vue